import React, { useEffect, useState } from "react";
import UserOpenJobsListing from "../UserOpenJobsListing";
import SharedOpenJobsList from "../SharedOpenJobsList";
import { CommonHeader } from "../../../components/commons";
import JobsPendingApprovalListing from "../JobsPendingApprovalListing";
import JobsCompletionStatusListing from "../JobsCompletionStatusListing";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import CommentDueTomorrowListing from "../CommentDueTomorrowListing";
type TabsType = {
  name: string;
  label: string;
};
const tabs: TabsType[] = [
  {
    name: "All Open Jobs",
    label: "allOpenJobs",
  },
  {
    name: "Comment Due Tomorrow",
    label: "commentDueTomorrow",
  },
  {
    name: "Shared with Me",
    label: "sharedWithMe",
  },
  {
    name: "Jobs Pending Approval",
    label: "jobsPendingApproval",
  },
  {
    name: "Jobs Completion Status",
    label: "jobsCompletionStatus",
  },
 
];
type AppProps = {
  history: any;
  loginData: LoginResponseType;
};
const AllOpenJobs = ({ history, loginData }: AppProps) => {
  const redirectActiveTab = history?.location?.state?.activeTab;
  //========== User Management ==========//
  const [isPendingApprovalListPresent, setIsPendingApprovalListPresent] =
    useMenuCheck("open jobs");
  const [
    isJobsCompletionStatusListPresent,
    setIsJobsCompletionStatusListPresent,
  ] = useMenuCheck("open jobs");
  //====================//

  const [activeTab, setActiveTab] = useState(
    redirectActiveTab ? redirectActiveTab : tabs[0].label
  );

  useEffect(() => {
    setIsPendingApprovalListPresent(
      "All Open Jobs Pending Approval List",
      "menu"
    );
    setIsJobsCompletionStatusListPresent("Jobs Completion Status List", "menu");
  }, []);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const renderTabs = () => {
    const filteredTabs = tabs.filter((tab) => {
      if (!isPendingApprovalListPresent && !isJobsCompletionStatusListPresent) {
        return (
          tab.label !== "jobsPendingApproval" &&
          tab.label !== "jobsCompletionStatus"
        );
      } else if (
        isPendingApprovalListPresent &&
        isJobsCompletionStatusListPresent
      ) {
        return tab;
      } else if (
        isJobsCompletionStatusListPresent &&
        !isPendingApprovalListPresent
      ) {
        return tab.label !== "jobsPendingApproval";
      } else if (
        isPendingApprovalListPresent &&
        !isJobsCompletionStatusListPresent
      ) {
        return tab.label !== "jobsCompletionStatus";
      }
    });

    const finalTab = filteredTabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer mr-2"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };
  const activeTabRender = () => {
    switch (activeTab) {
      case "allOpenJobs":
        return <UserOpenJobsListing history={history} />;
      case "sharedWithMe":
        return <SharedOpenJobsList />;
      case "jobsPendingApproval":
        return <JobsPendingApprovalListing />;
      case "jobsCompletionStatus":
        return <JobsCompletionStatusListing loginData={loginData} />;
      case "commentDueTomorrow":
        return <CommentDueTomorrowListing history={history} />;
      default:
        return <UserOpenJobsListing history={history} />;
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="All Open Jobs" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div className="d-flex">{renderTabs()}</div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginData: state.auth.loginData,
});

export default connect(mapStateToProps, null)(AllOpenJobs);
